import { RouteConfig } from 'src/routing/types'

const ROUTE: RouteConfig = {
  name: 'return-policy',
  path: () => '/return-policy',
}

export default ROUTE
